import axios from 'axios';

const backendUrl = 'https://associado.apergs.org.br:21598'
// const backendUrl = 'http://192.168.0.254:21598'
// const backendUrl = 'http://localhost:21598'
// const backendUrl = "https://apps.delphus.inf.br:21599"; //ambiente teste


const api = axios.create({
    baseURL: backendUrl + `/api/`,
});


api.getComboData = async (table, parameter) => {
    return new Promise(async (resolve, reject) => {
        console.log('Searching for parameter ' + parameter)
        await api.get('/' + table + '/combo' + (parameter ? '/' + parameter : '')).then(async r => {
            console.log(r.data)
            resolve(r.data)
        })
    })

}

api.getComboDataWhere = async (table, parameter) => {
    console.log(parameter)
    return new Promise(async (resolve, reject) => {
        await api.get('/' + table + '/combo?' + parameter).then(async r => {
            console.log(r.data)
            resolve(r.data)
        })
    })
}


api.getAcessos = async (tela, opcao) => {
    return new Promise(async (resolve, reject) => {
        // console.log('Searching for parameter '+tela+' '+opcao)
        let auth = JSON.parse(localStorage['authApergs']);

        await api.get('/grupo_usuarios/permissoes?tela=' + tela + '&pk_usu=' + auth.user + '&acao=' + opcao).then(async r => {
            if (opcao === 'Consulta') {
                try {
                    resolve(r.data[0].Consulta)
                }
                catch { resolve('N') }
            }

            if (opcao === 'Inclusao') {
                try {
                    resolve(r.data[0].Inclusao)
                }
                catch { resolve('N') }
            }

            if (opcao === 'Alteracao') {
                try {
                    resolve(r.data[0].Alteracao)
                }
                catch { resolve('N') }
            }

            if (opcao === 'Exclusao') {
                try {
                    resolve(r.data[0].Exclusao)
                }
                catch { resolve('N') }
            }

            // resolve(r.data)
        })
    })
}


api.getListData = async (table, parameter) => {
    return new Promise(async (resolve, reject) => {
        console.log('Searching for parameter ' + parameter)
        await api.get('/' + table + '/lista' + (parameter ? '/' + parameter : '')).then(async r => {
            console.log(r.data)
            resolve(r.data)
        })
    })
}

api.getImage = async (lote, image) => {
    return new Promise(async (resolve, reject) => {
        if (lote && image) {
            console.log('Trying to find image ' + image + ' of lot ' + lote)
            axios.get(backendUrl + '/static/upload/lotes/' + lote + '/' + image).then(r => {
                resolve(backendUrl + '/static/upload/lotes/' + lote + '/' + image)
            }).catch(e => resolve(backendUrl + '/static/upload/lotes/no-image.jpg'))
        } else resolve(backendUrl + '/static/upload/lotes/no-image.jpg')
    })
}

api.noImageUrl = backendUrl + '/static/upload/lotes/no-image.jpg'
api.backendUrl = backendUrl

export default api